export default "__VITE_ASSET__DIlMrH59__"